"use client";
import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { Icon as a, Paragraph as t } from "@ingeniorforeningen/figurine-core";
import '../../../assets/EditLinkWrapper.css';const o = "_link_1ao5j_2", s = {
  link: o
}, k = ({ backofficeDisplayName: r, editLink: i }) => /* @__PURE__ */ n("a", { href: i, target: "_blank", rel: "noreferrer", className: s.link, children: [
  /* @__PURE__ */ e(a, { name: "Edit", size: "xs", "aria-label": "EditIcon" }),
  /* @__PURE__ */ e(t, { text: r })
] });
export {
  k as CmsBackofficeLink
};
